export function trackInteractivityEvents() {
  // Copy event
  $(document).on('copy', () => {
    let selectedText = window.getSelection().toString().trim()
    if (selectedText.length === 0) return

    // if the text is selected

    // Limit selectedText to 2048 characters
    if (selectedText.length > 2048) {
      selectedText = selectedText.slice(0, 2048)
    }

    const category = "user_interaction"
    const action = "copy_question_text"
    sendCheatingEvent(category, action, selectedText)
  })

  // Paste event
  $(document).on('paste', (e) => {
    const $target = $(e.target)
    if ($target.is('input, textarea')) {
      const category = "user_interaction"
      const action = "paste_answer_text"
      sendCheatingEvent(category, action)
    }
  })

  // Right-click / context menu
  $(document).on('contextmenu', () => {
    const category = "user_interaction"
    const action = "right_click"
    sendCheatingEvent(category, action)
  })

  // Left for later
  // let selectionTimer
  // $(document).on('selectionchange', () => {
  //   const selectedText = window.getSelection().toString().trim()
  //   clearTimeout(selectionTimer)
  //   selectionTimer = setTimeout(() => {
  //     if (selectedText.length > 0) {
  //       category = "user_interaction"
  //       action = "text_selection"
  //       sendCheatingEvent(category, action, selectedText)
  //     }
  //   }, 300) // Debounce to avoid noise
  // })

  // Window blur/focus
  $(window).on('blur', () => {
    const category = "window_activity"
    const action = "window_blur"
    sendCheatingEvent(category, action)
  })

  $(window).on('focus', () => {
    const category = "window_activity"
    const action = "window_focus"
    sendCheatingEvent(category, action)
  })

  screenshotEvent()
}

function screenshotEvent() {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0

  if (isMac) {
    macKeyCombinations()
  }
}

function macKeyCombinations() {
  // MacOs users
  let heldModifiers = []
  const modifiers = ['shift', 'meta', 'control', 'alt']

  $(document).on('keydown', (e) => {
    const key = e.key.toLowerCase();

    if (modifiers.includes(key)) {
      if (!heldModifiers.includes(key)) {
        heldModifiers.push(key);
      }

      if (heldModifiers.length >= 2) { // only if 2 modifiers were pressed at the same time
        const hasControl = heldModifiers.includes('control');
        const hasAlt = heldModifiers.includes('alt');

        if (!(hasControl && hasAlt)) { // exclude Control + Option combination for screen readers
          sendScreenShotEvent()
        }
      }
    }
  })

  $(document).on('keyup', (e) => {
    // remove the released key from the array
    const key = e.key.toLowerCase();

    if (modifiers.includes(key)) {
      heldModifiers = heldModifiers.filter(k => k !== key);
    }
  })
}

function sendScreenShotEvent() {
  const category = "user_interaction"
  const action = "screenshot"
  sendCheatingEvent(category, action)
}

function sendCheatingEvent(category, action, selectedText) {
  const url = window.location.href

  const snowplowData =  {
    category,
    action,
    page_url: url
  }

  if (selectedText) snowplowData.selected_text = selectedText

  snowplow('trackSelfDescribingEvent', {
    event: {
      schema: 'iglu:org.sophia/user_interaction/jsonschema/1-0-0',
      data: snowplowData
    }
  })

  // TODO: add GA4 events when the story is ready
}
